// extracted by mini-css-extract-plugin
module.exports = {"root":"suggestedProduct_root__1ciDN","image":"suggestedProduct_image__1MMcv","thumbnail":"suggestedProduct_thumbnail__3J-QT","name":"suggestedProduct_name__XgcRM"};